<template>
	<div class="dt" v-title="'齐齐直播'">
		<navtop v-bind:index="'dating'"></navtop>
		<div class="menu">
			<i class="iconfont" v-on:click="showSearch">&#xe967;</i>
			<div class="search" v-if="searchShow">
				<div class="searchCon">
					<input type="tel" placeholder="请输入6位房间号" v-model="searchId" v-focus="searchShow" />
					<a v-on:click="searchRoom"><img src="../../img/dating/search2.png"/></a>
				</div>
				<i></i>
			</div>
			<div class="tabWrap">
				<ul>
					<li v-bind:class="{cur:navIndex==1}" v-on:click="navIndex=1">
						<a>大厅</a>
					</li>
					<li v-bind:class="{cur:navIndex==5}" v-on:click="navIndex=5">
						<a>女神</a>
					</li>
					<li v-bind:class="{cur:navIndex==2}" v-on:click="navIndex=2">
						<a>新人</a>
					</li>
					<!--<li v-bind:class="{cur:navIndex==10}" v-on:click="navIndex=10">
						<a>红人</a>
					</li>-->
					<li v-bind:class="{cur:navIndex==3}" v-on:click="navIndex=3">
						<a>好声音</a>
					</li>
					<li v-bind:class="{cur:navIndex==4}" v-on:click="navIndex=4">
						<a>型男</a>
					</li>
				</ul>
			</div>
			<div class="pop" v-if="popTips||tips.con">
				<p>{{tips.con}}</p>
				<div v-on:click="confirmTips">确定</div>
				<i v-on:click="closeTips">x</i>
			</div>
		</div>
		<!--主播列表-->
		<div class="anchorList"  v-bind:style="'height:'+scrollHeight+';overflow:scroll;-webkit-overflow-scrolling: touch;'">
			<ul>
				<li v-for="(item,index) of showList" v-if="index<lazyImg">
					<a v-on:click="checkLogin(item.roomId)">
						<img class="pic" v-bind:src=" typeof item.anchorPic == 'object'?('https://qiqi-resource-v6.qxiu.com'+item.anchorPic[0].slice(29)):('https://qiqi-resource-v6.qxiu.com'+JSON.parse(item.anchorPic)[0].slice(29))" />
						<h3>{{subString(item.anchorName,9,true)}}<span><img class="viewer" src="../../img/dating/viewer.png">{{item.roomNum}}</span></h3>
						<span class="label" v-if="item.happyPk==0"></span>
						<span class="labelPk" v-if="item.happyPk!=0"></span>
					</a>
				</li>
				<li class="loadingMore" v-if="loadingMore">
					<img src="../../img/dating/loading.png" />
					<span>加载中..</span>
				</li>
			</ul>
		</div>
		<component v-bind:is="curview"></component>
		<!--<navbottom v-bind:index="navBott"></navbottom>-->
		<div class="loadingImg" v-if="loadingImg">
			<img src="../../img/dating/loading.png" />
			<span>加载中..</span>
		</div>
		<div class="downEntry" v-on:click="download" v-if="isxiaoxiong" v-bind:style="'background:url(https://static.qxiu.com/h5/static/down3.png);background-size:4.68rem 2.08rem;display:'+(!isAndroid&&isYouxi?'none':'block')"></div>
		<div class="downEntry2" v-on:click="download" v-if="!isxiaoxiong"></div>
		<div class="backGame" v-on:click="backGame" v-if="isYouxi"></div>
		<!--一键注册iphone12领回家-->
		<div class="tg202102" v-if="isShowTgy" v-on:click="isShowTgy=false">
			<div class="content" v-on:click="toRegist"></div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import cookie from '../../libs/cookie'
	import passPort from '../../libs/passport'
	import webLog from '../../libs/webLog'
	import navtop from '../dating/navTop'
	import navbottom from '../dating/navBottom'
	import phonelogin from '../dating/phoneLogin'
	import loginmode from '../dating/loginMode'
	import registmode from '../dating/registmode'

	export default {
		name: 'index',
		data() {
			return {
				navBott: 0,
				navIndex: 1,
				showList: '',
				lazyImg: 10, //懒加载
				searchShow: false, //搜索框
				searchId: '', //房间号搜索
				popTips: false,
				loadingImg:false,
				scrollHeight:'',
				loadingMore:false,
				timmer:null,
				countDown:false, //滚动回调事件禁止倒计时内
				isAndroid:false,
				isShowTgy: false
			}
		},
		components: {
			navtop,
			navbottom,
			phonelogin,
			loginmode,
			registmode
		},
		computed:{
			isxiaoxiong(){
				return cookie.get('isxiaoxiong')=='true'
			},
			...mapState(
				[
					'curview','tips','isYouxi'
				]
			),
		},
		mounted() {
			
			var u = navigator.userAgent;
			this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
					
			var channelid = cookie.get('channelid')||0,oemid= cookie.get('oemid')||201;
			if(this.querystr("channelid")){
				channelid =this.querystr("channelid")
			}
			if(this.querystr("oemid")){
				oemid =this.querystr("oemid")
			}
			this.$store.commit('getChannelID', channelid)
			cookie.set('channelid',channelid, {domain: 'qxiu.com',encode: true})
			cookie.set('oemid',oemid, {domain: 'qxiu.com',encode: true})
			
			if(this.querystr("sourceType")){
				this.$store.commit('getSourceType', this.querystr("sourceType"))
			}
			if(passPort.isLogin()){
				this.$store.commit('getIsLogin', true)
				if(!cookie.get('photo')||cookie.get('photo')=='null'||cookie.get('photo')=='undefined'){
					if(this.isxiaoxiong){
						cookie.set('photo',"https://static.qxiu.com/h5/static/xiaoxiong.png", {domain: 'qxiu.com',encode: true})
					}else{
						cookie.set('photo',"https://static.qxiu.com/h5/static/img/app.png", {domain: 'qxiu.com',encode: true})
					}
					
				}
			}else{
				this.$store.commit('getIsLogin', false)
			}
			
//			if(sessionStorage.dtRecharge && cookie.get('uid')){
//				sessionStorage.dtRecharge=''
//				location.hash="/recharge"
//			}
			if((channelid == 731100001)||(channelid == 731100002)){
				this.$store.commit('isYouxi', true)
				if(!passPort.isLogin()){
					this.toLoginYx() //游戏登陆
				}
			}else{
				this.$store.commit('isYouxi', false)
			}
			
			var _this = this
			$.ajax({
				type: "post",
				url: "https://hot-active.qxiu.com/hallhome/mobile/getMobileAnchorRank?tag=1",
				async: true,
				dataType: "jsonp",
				success: function(res) {
					if(res.retcode==0 && res.result.anchors){
						var list = [];
						for( var i = 0; i<res.result.anchors.length;i++){
							list = list.concat(res.result.anchors[i].list)
						}
						_this.showList = list
					}
				}
			});
			_this.getSuperNewStar();
			
			$('.anchorList').on('scroll',function() {
				if(_this.showList.length - _this.lazyImg <0){
					return
				}
				if($('.anchorList ul').height()-$('.anchorList').height()-$('.anchorList').scrollTop() <= 300&&!_this.curview &&!_this.loadingImg &&_this.countDown== false) {
					_this.loadingMore=true;
					_this.countDown=true;
					var timer2=setTimeout(function(){
						_this.loadingMore=false;
						_this.countDown=false;
						_this.lazyImg += 10;
						clearTimeout(timer2)
					},1500)
					clearTimeout(_this.timer)
					_this.timer=null;
				}
			})
			
			webLog.PV()
			webLog.dataReport()
			
			var height=document.documentElement.clientHeight
			this.scrollHeight=height/parseInt($('html').css('font-size'))-5+'rem';
			
			channelid=channelid-0;
			if((100060001<=channelid &&channelid<=100060006)||(100070001<=channelid &&channelid<=100070054)||(100080001<=channelid &&channelid<=100080014)|| channelid==10009){
				if(!passPort.isLogin()){
					_this.$store.commit('getCurview', 'loginmode')
					_this.$store.commit('getForceLogin', true)
				}
			}
			
			if(channelid == '505'){
				console.log(12312132)
				this.isShowTgy = true
			}
		},
		methods: {
			toLoginYx(){	//划水麻将游戏登陆
				var _this = this;
				cookie.set('scheme', _this.querystr("scheme"), {domain: 'qxiu.com'})
				$.ajax({
					type: "post",
					url: "https://login-m.qxiu.com/cgi/partner/login?appid=leshi&code="+ _this.querystr("code") +"&area="+ _this.querystr("area") +"&scheme="+ _this.querystr("scheme") +"",
					async: true,
					dataType: "jsonp",
					success: function(res) {
						if(res.state==0 && res.content.uid){
							cookie.set('isNew', res.content.isnew, {domain: 'qxiu.com'})
							cookie.set('mcheck', res.content.meck, {domain: 'qxiu.com'})
							cookie.set('nick', res.content.nick, {domain: 'qxiu.com'})
							cookie.set('openid', res.content.openid||1, {domain: 'qxiu.com'})
							cookie.set('accessToken', res.content.openkey||1, {domain: 'qxiu.com'})
							cookie.set('uid', res.content.uid, {domain: 'qxiu.com'})
							cookie.set('photo', res.content.portrait, {domain: 'qxiu.com'})
//							cookie.set('webToken', res.content.webToken, {domain: 'qxiu.com'})
							location.reload();
						}
					}
				});
			},
			getSuperNewStar(){
				var _this = this;
//				获取超新星
				$.ajax({
					type: "post",
					url: "https://cgi-client.qxiu.com/hall/starAnchor/getRecList",
					async: true,
					dataType: "jsonp",
					success: function(res) {
						if(res.state==0 && res.content.list){
							_this.showList = res.content.list.concat(_this.showList )
						}
					}
				});
			},
			querystr(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if(r != null) return unescape(r[2]);
				return null;
			},
			subString(str, len, hasDot) {
			    if(null == str || undefined == str){
			        str = '';
			    }
			    str = str.replace(/&nbsp;/g, ' ');
			    var newLength = 0;
			    var newStr = "";
			    var chineseRegex = /[^\x00-\xff]/g;
			    var singleChar = "";
			    var strLength = str.replace(chineseRegex, "**").length;
			
			    for (var i = 0; i < strLength; i++) {
			        singleChar = str.charAt(i).toString();
			        if (singleChar.match(chineseRegex) != null) {
			            newLength += 2;
			        } else {
			            newLength++;
			        }
			        if (newLength > len) {
			            break;
			        }
			        newStr += singleChar;
			    }
			    if (hasDot && strLength > len) {
			        newStr += "...";
			    }
			    return newStr;
			},
			checkLogin(roomId) {
//				if(passPort.isLogin()) {
					if(this.navIndex == 10){
						location.href = location.protocol+"//h5.qxiu.com/roomFull.html?roomid=" + roomId + "&channelid=" +cookie.get('channelid')
					}else{
						location.href = location.protocol+"//h5.qxiu.com/room.html?roomid=" + roomId+ "&channelid=" +cookie.get('channelid')
					}
					
//				} else {
//					this.$store.commit('getCurview', 'loginmode')
//				}
			},
			searchRoom() {
				this.popTips = false
				let reg = /^[23478]\d{5}$/g
				if(reg.test(this.searchId)) {
					this.$store.commit('getSearchRoomId', this.searchId)
					cookie.set('searchRoomId',this.searchId,{domain:"qxiu.com"})  
					location.hash = '/search?'
				} else {
					this.$store.commit('getTips', {con:'请输入以2/3/4/7/8开头的6位数字！'})
				}
			},
			showSearch() {
				this.searchShow = !this.searchShow
			},
			confirmTips(){
				if(this.tips.func){this.tips.func()}
				this.$store.commit('getTips', '')
			},
			closeTips(){
				this.$store.commit('getTips', '')
			},
			isWeixin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true;
				} else {
					return false;
				}
			},
			download(){
				var _this = this;
				var u = navigator.userAgent,
					isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
					isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
					channelid = cookie.get('channelid')>0?cookie.get('channelid'):10001
				_hmt.push(['_trackEvent', "下载按钮", "click",'006']);//百度统计
				if(isiOS){
//					location.href = "https://apps.apple.com/cn/app/id1450233438?l=zh&ls=1"
					location.href = "http://ios.qxiu.com/LoveQiMiaoLive"
				}else{
					var downloadUrl;
					if(cookie.get('channelid')==731300001){
						downloadUrl = 'https://m.qxiu.com/download/qx/download.jsp?channelid=713&oemid=31';
					}else if(cookie.get('channelid')==731300003){
						downloadUrl = 'https://m.qxiu.com/download/qx/download.jsp?channelid=120&oemid=31';
					}else if(cookie.get('channelid')==740900023){
						downloadUrl = 'http://c.img001.com/qxiu/QiQi506.apk';
					}else if(_this.isYouxi){
						downloadUrl = 'qqzbdownload://m.qxiu.com/download/qx/download.jsp?channelid=700&oemid=31'
					}else{
						downloadUrl = 'https://m.qxiu.com/download/qx/download.jsp?channelid='+channelid+"&oemid="+(_this.isxiaoxiong?31:15)
					}
					
					if(isAndroid && this.isWeixin()){
						_AP.pay(downloadUrl)
					}else{
						location.href = downloadUrl;
					}
				}
			},
			backGame(){
				location.href =  (cookie.get('scheme')||'miaqiyx') + '://miaqiyx';
			},
			toRegist(){
				this.$store.commit('getCurview', 'registmode')
			}
		},
		watch: {
			navIndex() {
				var _this = this
				_this.loadingImg=true;
				_this.showList = ''
				$.ajax({
					type: "post",
					url: "https://hot-active.qxiu.com/hallhome/mobile/getMobileAnchorRank?tag=" + this.navIndex,
					async: true,
					dataType: "jsonp",
					success: function(res) {
						_this.lazyImg = 10
						if(_this.navIndex == 1) {
							if(res.retcode==0 && res.result.anchors){
								var list = [];
								for( var i = 0; i<res.result.anchors.length;i++){
									list = list.concat(res.result.anchors[i].list)
								}
								_this.showList = list
							}
							_this.getSuperNewStar();
						} else {
							var reqIndex =  /tag=(\d{1,2})/.exec(this.url.slice(this.url.indexOf('tag')))[1] //获取请求的tagid
							if(reqIndex == _this.navIndex){
								_this.showList = res.result.anchors
							}
						}
						_this.loadingImg=false
					}
				});
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.dt {
		overflow: hidden;
	}
	
	.menu {
		position: fixed;
		width: 14.2rem;
		height: 1.16rem;
		top: 2.2rem;
		padding: 0.6rem 0.4rem 0.44rem;
		background: #fff;
		z-index: 100;
	}
	
	.menu .iconfont {
		float: left;
		font-size: 0.72rem;
		margin: 0 0.5rem 0 0.2rem;
		line-height: 1.16rem;
	}
	.tabWrap{
		width: 12.6rem;
		overflow: scroll;
	}
	.tabWrap::-webkit-scrollbar { width: 0 !important }
	
	.menu ul {
		width: 19rem;
		float: left;
		text-align: center;
	}
	
	.menu li {
		float: left;
		padding: 0 0.8rem;
		margin: 0 0.12rem;
		display: inline-block;
		background: #F5ECFF;
		height: 1.16rem;
		border-radius: 0.58rem;
	}
	
	
	.menu li a {
		font-size: 0.48rem;
		color: #9a51ff;
		line-height: 1.16rem;
	}
	
	.menu li.cur{
		background: linear-gradient(to right,#FF76DD,#913BED);
	}
	.menu li.cur a {
		color: #fff;
	}
	
	.anchorList {
		margin-top: 4.4rem;
		padding-bottom: 1rem;
		overflow: hidden;
		background: #fff;
	}
	.anchorList::-webkit-scrollbar {display: none;}
	.anchorList ul {
		overflow: hidden;
		padding-left: 0.4rem;
	}
	.anchorList li {
		position: relative;
		float: left;
		width: 7rem;
		height: 7rem;
		margin: 0 0.2rem 0.2rem 0;
		overflow: hidden;
		border-radius: 0.4rem;
	}
	
	.anchorList li:nth-child(2n) {
		margin:  0 0 0.2rem 0;
	}
	.anchorList .loadingMore{
		text-align: center;
		width: 100%;
		height: 2rem;
		margin-top: 1rem;
	}
	.anchorList .loadingMore  img{
		position: static;
		left: 50%;
		vertical-align: middle;
		width: 1rem;
		height: 1rem;
		animation: roll 2s linear 0s infinite normal;
	}
	
	.anchorList li:not(.loadingMore) .pic {
		height: 100%;  
    	width: auto;  
	    left:50%;  
	    position: relative;  
	    -webkit-transform: translateX(-50%);  
	    -ms-transform: translateX(-50%);  
	    -moz-transform: translateX(-50%);  
	}
	
	.anchorList li h3 {
		position: absolute;
		width: 6.4rem;
		padding: 0 0.3rem;
		bottom: 0.3rem;
		color: #fff;
		font-size: 0.52rem;
	}
	.anchorList li .label{
		position: absolute;
		top: 0.2rem;	
		right: 0.2rem;
		width: 1.58rem;
		height: 0.6rem;
		background: url(../../img/dating/live.png) no-repeat;
		background-size: 100%;
	}
	.anchorList li .labelPk{
		position: absolute;
		top: 0.2rem;	
		right: 0.2rem;
		width: 1rem;
		height: 0.6rem;
		background: url(../../img/dating/PKMark2.png) no-repeat;
		background-size: 100%;
	}
	
	.anchorList h3 span {
		padding-top: 0.1rem;
		font-size: 0.44rem;
		float: right;
	}
	.anchorList h3 span .viewer{
		width: 0.24rem;
		height: 0.34rem;
		vertical-align: baseline;
		margin-right: 0.16rem;
	}
	.anchorList li a{
		display: block;
		width: 100%;
		height: 100%;
		font-size: 0;
	}
	.search {
		position: absolute;
		width: 15rem;
		bottom: -2.35rem;
		left: 0;
		background: #fff;
	}
	
	.search>i {
		display: none;
		/*position: absolute;
		top: -0.28rem;
		left: 0.5rem;
		border-bottom: 0.3rem solid #E8E8E8;
		border-left: 0.28rem solid transparent;
		border-right: 0.28rem solid transparent;*/
	}
	
	.searchCon {
		width: 13.63rem;
		border-radius: 0.8rem;
		margin: 0.4rem auto;
		padding-left: 0.56rem;
		background: #F3F3F3;
	}
	
	.searchCon input {
		height: 1.6rem;
		width: 10.8rem;
		font-size: 0.52rem;
		line-height: 0.6rem;
		border: none;
		outline: none;
		background: transparent;
	}
	
	.searchCon a {
		float: right;
		width: 2.8rem;
		height: 1.6rem;
		vertical-align: top;
		text-align: center;
		line-height: 1.6rem;
		font-size: 0.6rem;
		border-top-right-radius: 0.8rem;
		border-bottom-right-radius: 0.8rem;
		background: #9E42FF;
		color: #fff;
	}
	
	.searchCon a img{
		width: 0.76rem;
		height: 0.76rem;
		vertical-align: middle;
	}
	
	.pop {
		width: 11.12rem;
		height: 4.8rem;
		position: absolute;
		top: 8rem;
		left: 50%;
		border: 1px solid #D5D5D3;
		margin: -2.9rem 0 0 -5.506rem;
		padding-top: 1.5rem;
		background: #FFF;
		border-radius: 0.4rem;
		text-align: center;
		box-shadow: 0 0 0.5rem #000;
		z-index: 10;
	}
	
	.pop div {
		width: 100%;
		border-top: 1px solid #ccc;
		color: #1381F1;
		margin: 1.4rem auto 0;
		line-height: 1.8rem;
		font-size: 0.6795rem;
	}
	
	.pop i {
		position: absolute;
		top: 0;
		right: 0.4rem;
		font-size: 0.84rem;
		color: #666;
		line-height: 1.1rem;
	}
	.pop p{
		margin-top: 0.8rem;
		font-size: 0.56rem;
		color: #666;
	}
	.loadingImg{
		position: fixed;
		top: 50%;
		left: 50%;
		width: 3rem;
		margin-left: -0.5rem;
		margin-top: -.5rem;
		
		/*-webkit-animation: roll 2s linear 0s infinite normal;*/
	}
	.loadingImg img{
		height: 1rem;
		vertical-align: middle;
		animation: roll 2s linear 0s infinite normal;
	}
	.loadingImg span{
		font-size:  0.52rem;
		color: #b8b8b8;;
	}
	
	.downEntry{
		position: fixed;
		left: 50%;
		bottom: 1.7rem;
		width: 4.68rem;
		height: 2.08rem;
		margin-left: -2.34rem;
		background: url(../../img/dating/down.png) no-repeat;
		background-size: contain;
	}
	.downEntry2{
		position: fixed;
		left: 50%;
		bottom: 1.7rem;
		width: 4.68rem;
		height: 2.08rem;
		margin-left: -2.34rem;
		background: url(../../img/dating/down2.png) no-repeat;
		background-size: contain;
	}
	
	.backGame{
		position: fixed;
		bottom: 3.5rem;
		right: 0.4rem;
		width: 2.2rem;
		height: 1rem;
		margin-left: -2.34rem;
		background: url(../../img/dating/backToGame.png) no-repeat;
		background-size: contain;
	}
	
	.tg202102{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 100;
	}
	.tg202102 .content{
		position: absolute;
		top: 8rem;
		left: 1.4rem;
		width: 11.4rem;
		height: 7.6rem;
		background: url('../../img/dating/tg2021.png') no-repeat;
		background-size: contain;
	}
	
	@keyframes roll{
	0 {transform: rotate(0);}
	50% {transform: rotate(180deg);}
	100% {transform: rotate(360deg);}
	}
</style>


// WEBPACK FOOTER //
// index.vue?ec5c0eec